// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"phone-locked"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M13.998 17.5H20.998V22H13.998V17.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10 22H5V2H19V10","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15.2495 17.5V15.75C15.2495 14.5074 16.2569 13.5 17.4995 13.5C18.7422 13.5 19.7495 14.5074 19.7495 15.75V17.5M13.998 17.5H20.998V22H13.998V17.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PhoneLockedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'phone-locked',
    ref,
    icon: element,
  },
));

PhoneLockedIcon.displayName = 'PhoneLockedIcon';

export default PhoneLockedIcon;
